import { footerLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="border-t border-secondary-200 bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div className="max-w-md">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-plant-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                香蕉社区
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              一个围绕图片、视频与会员分享的内容社区。我们持续整理资源、更新福利，也欢迎每一位成员把自己的分享留在这里。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                图片资源
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                视频内容
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                会员福利
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h3 className="font-heading text-sm font-semibold text-foreground-950">
                  {group.title}
                </h3>
                <ul className="mt-4 space-y-3">
                  {group.links.map((link) => (
                    <li key={link.id}>
                      <a
                        href={`#${link.id}`}
                        className="text-sm text-foreground-600 transition-colors hover:text-foreground-950"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 香蕉社区 · 内容用于学习与交流，资源授权请以素材标注为准。</p>
          <p>图片、视频与会员福利资源持续分享中</p>
        </div>
      </div>
    </footer>
  );
}